import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-arrow-left',
  imports: [],
  templateUrl: './icon-bold-arrow-left.component.html',
})
export class IconBoldArrowLeftComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
